import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "font-weight-bold mb-4" }
const _hoisted_3 = { class: "card" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "card-title" }, "Rechnungsübersicht")
], -1)
const _hoisted_5 = {
  key: 0,
  class: "media-list media-list-linked media-list-bordered"
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "d-flex flex-column align-items-center mr-3" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "icon-credit-card" }, null, -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { class: "media-body d-flex flex-column flex-md-row align-items-center overflow-hidden" }
const _hoisted_11 = { class: "d-flex flex-column mr-auto mr-md-5 text-opac-right text-wrap w-100 w-md-auto pr-md-3" }
const _hoisted_12 = { class: "media-heading font-weight-bold" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "d-none d-md-block" }, "RE vom ", -1)
const _hoisted_14 = { class: "text-muted" }
const _hoisted_15 = { class: "d-none d-md-block" }
const _hoisted_16 = { class: "d-flex flex-column text-wrap text-opac-right pr-md-3" }
const _hoisted_17 = {
  key: 0,
  class: "media-heading font-weight-bold"
}
const _hoisted_18 = {
  key: 1,
  class: "text-muted d-none d-md-block"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "ml-1 ml-md-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "list-icons" }, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "#",
      class: "list-icons-item"
    }, [
      /*#__PURE__*/_createElementVNode("i", { class: "icon-arrow-right15" })
    ])
  ])
], -1)
const _hoisted_20 = {
  key: 1,
  class: "card-body"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "alert alert-info col-12 mb-0" }, "Keine Ergebnisse gefunden", -1)
const _hoisted_22 = [
  _hoisted_21
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FilterBar = _resolveComponent("FilterBar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.headline), 1),
    _createVNode(_component_FilterBar, {
      filter: _ctx.filter,
      search: _ctx.search,
      onFilter: _ctx.onFilter
    }, null, 8, ["filter", "search", "onFilter"]),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createVNode(_Transition, {
        name: "fade",
        mode: "out-in"
      }, {
        default: _withCtx(() => [
          (_ctx.filteredInvoice.all.length > 0)
            ? (_openBlock(), _createElementBlock("ul", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredInvoice.all, (invoice, index) => {
                  return (_openBlock(), _createElementBlock("li", { key: index }, [
                    _createElementVNode("a", {
                      class: "media cursor-pointer align-items-center",
                      onClick: ($event: any) => (_ctx.showDetail(invoice))
                    }, [
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("a", {
                          href: "#",
                          class: _normalizeClass(["btn bg-transparent rounded-pill border-2 btn-icon ml-1 mr-1 ml-md-3 mr-md-3", ['text-'+invoice.class, 'border-'+invoice.class]])
                        }, _hoisted_9, 2),
                        _createElementVNode("small", {
                          class: _normalizeClass(["mx-auto", 'text-'+invoice.class])
                        }, _toDisplayString(invoice.statusName), 3)
                      ]),
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                          _createElementVNode("span", _hoisted_12, [
                            _hoisted_13,
                            _createTextVNode(_toDisplayString(_ctx.moment(invoice.datum).format('DD.MM.YYYY')), 1)
                          ]),
                          _createElementVNode("span", _hoisted_14, [
                            _createElementVNode("span", _hoisted_15, "#" + _toDisplayString(invoice.uid) + " - ", 1),
                            _createTextVNode(" " + _toDisplayString(invoice.betrag) + " Euro", 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_16, [
                          (invoice.pid && invoice.pid !== '')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(invoice.p_firma ? invoice.p_firma + ' | ' : '') + " " + _toDisplayString(invoice.p_vorname) + " " + _toDisplayString(invoice.p_name), 1))
                            : _createCommentVNode("", true),
                          (invoice.pid && invoice.pid !== '')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(invoice.p_strasse) + " " + _toDisplayString(invoice.p_hnr) + ", " + _toDisplayString(invoice.p_plz) + " " + _toDisplayString(invoice.p_ort), 1))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _hoisted_19
                    ], 8, _hoisted_6)
                  ]))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_20, _hoisted_22))
        ]),
        _: 1
      })
    ])
  ]))
}